<template>
  <div class="full-size auto-overflow">
    <v-list dense color="rgba(0 0 0 0)" two-line>
      <v-list-item-group
        v-model="selected"
        active-class="primary--text"
        :multiple="multiple"
        @change="input"
      >
        <template v-for="(item, index) in items">
          <v-list-item :key="item.id" dense @click="$emit('select', item)">
            <slot :item="item">
              <template>
                <v-list-item-content>
                  <v-list-item-title
                    ><h3>{{ item.name }}</h3></v-list-item-title
                  >
                  <v-list-item-subtitle class="ui-text-italic">{{
                    item.id
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </slot>
          </v-list-item>

          <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "HiList",
  components: {},
  data() {
    return {
      selected: [],
      value: null
    };
  },
  props: {
    items: {},
    multiple: {
      type: Boolean
    }
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style scoped>
::v-deep .v-list {
  background: none;
  padding: 0;
}
</style>
